export default function formatErrorMessage(err, title) {
  const apiError =
    err.message ||
    (err.response.status && `Error occurred with status code ${err.response.status}`) ||
    'Unknown error occurred.';
  const errorDetails =
    err.response && err.response.data
      ? JSON.stringify(err.response.data, null, 2)
      : 'Unknown';
  return `<b>${title}</b><br/><br/><pre class="error-details"><b>Error:</b> ${apiError}<br/><b>Details:</b> ${errorDetails}</pre>`;
}